<template>
  <el-card>
    <!-- 表单 -->
    <div class="top">
      <div class="searchForm">
        <el-form
          :inline="true"
          ref="searchForm"
          :model="searchForm"
          class="searchForm"
          @submit.native.prevent
          @keyup.enter.native="searchList"
        >
          <el-form-item label="" prop="keyword">
            <el-input
              v-model="searchForm.name"
              clearable
              placeholder="请输入资源名称"
              @clear="searchList"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchList">查 询</el-button>
            <el-button @click="resetForm">重 置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="right">
        <el-button
          v-if="jurisdiction.cdnResourceTools_upload"
          class="float-right"
          type="primary"
          @click="onAdd"
        >
          上传资源
        </el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table :data="list">
      <el-table-column label="资源名称" prop="name" />
      <el-table-column label="资源路径" prop="cdn_url">
        <template slot-scope="scope">
          <a class="link" :href="scope.row.cdn_url" target="_blank">{{ scope.row.cdn_url }}</a>
        </template>
      </el-table-column>
      <el-table-column label="缩略图">
        <template slot-scope="scope">
          <el-image
            v-if="isImg(scope.row.cdn_url)"
            class="img"
            :src="scope.row.cdn_url"
            :preview-src-list="[scope.row.cdn_url]"
          />
        </template>
      </el-table-column>
      <el-table-column label="上传时间" prop="create_time">
        <template slot-scope="scope">
          <span>
            {{ dayjs(get(scope.row, 'create_time') * 1000).format('YYYY-MM-DD HH:mm:ss') }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="上传人" prop="create_by.name">
        <template slot-scope="scope">
          <span>{{ get(scope.row, 'create_by.name') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remark" />
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button @click="onCopy(scope.row)" type="text" size="small">复制链接</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />
    <create-cdn-resource
      :visible="visible"
      :row="editData"
      :type="openType"
      @close="visible = false"
      @refresh="getList"
    />
  </el-card>
</template>

<script>
import CreateCdnResource from './components/createCdnResource.vue';
import { cdnResourceList } from '@/graphql/api/cdn_resource';
import dayjs from 'dayjs';
import { get } from 'lodash';
import { mapGetters } from 'vuex';

export default {
  components: { CreateCdnResource },
  data() {
    return {
      // 搜索表单
      searchForm: {
        name: '',
      },
      payload: {
        limit: 10,
        offset: 0,
      },
      page: 1,
      pageSize: 10,
      total: 0,
      // 表格
      loading: false,
      list: [],
      // 弹窗
      visible: false,
      editData: {},
      openType: 'create',
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']), // user 模块名称
    jurisdiction() {
      const jurisdictionArray = ['cdnResourceTools_upload'];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      return jurisdictionObj;
    },
  },
  async created() {
    this.getList();
  },
  methods: {
    dayjs,
    get,
    async getList() {
      this.loading = true;
      this.payload = {
        ...this.payload,
        limit: this.pageSize,
        offset: (this.page - 1) * this.pageSize,
      };
      try {
        const res = await cdnResourceList({
          name: this.payload.name ? `%${this.payload.name}%` : '%%',
          limit: this.payload.limit,
          offset: this.payload.offset,
        });
        const data = res.cdn_resource;
        this.list = data?._data;
        console.log('cdn resource list: ', this.list);
        this.total = parseInt(data?._aggregate?.count || 0);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.list = [];
        this.loading = false;
      }
    },
    onAdd() {
      this.editData = {};
      this.openType = 'create';
      this.visible = true;
    },
    // 翻页器
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getList();
    },
    searchList() {
      this.page = 1;
      this.payload.name = this.searchForm.name || '';
      this.getList();
    },
    resetForm() {
      this.searchForm.name = '';
      delete this.payload.name;
      this.getList();
    },
    onCopy(row) {
      navigator.clipboard
        .writeText(row.cdn_url)
        .then(() => {
          this.$message.success('复制成功');
        })
        .catch((err) => {
          this.$message.error('Failed to copy text: ', err);
        });
    },
    isImg(url) {
      const extension = url.split('.').pop().toLowerCase();
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(extension);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/input.scss';
@import '@/styles/element/select.scss';
@import '@/styles/element/button.scss';
@import '@/styles/element/tab.scss';
@import '@/styles/element/table.scss';
@import '@/styles/element/dropdown.scss';
@import '@/styles/element/pagination.scss';

.top {
  display: flex;

  .searchForm {
    flex: 1;
  }
}

.app-select {
  width: 120px;
}

.link {
  color: var(--Text-Brand-default);
}

.img {
  width: 100px;
  height: 100px;
}
</style>
